import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-programs',
  templateUrl: './programs.component.html',
  styleUrls: ['./programs.component.less']
})

export class ProgramsComponent implements OnInit {
  @Input() programs;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/programs/programs.component.ts